import React from 'react';
import YouTube from 'react-youtube';
import {intervalStart, intervalEnd} from './util';

class VideoPlayer extends React.Component {
  shouldComponentUpdate() {
    return false
  }
  seekTo(time) {
    this.stopPreloading()
    this.player.unMute()
    this.player.seekTo(time)
  }
  play() {
    this.stopPreloading()
    this.player.unMute()
    this.player.playVideo()
  }
  pause() {
    this.stopPreloading()
    this.player.mute()
    this.player.pauseVideo()
  }
  reset() {
    this.pause()
    this.seekTo(intervalStart(this.props.video.range))
  }
  getCurrentTime() {
    return this.player.getCurrentTime()
  }
  getPlayerState() {
    return this.player.getPlayerState()
  }

  preload(onDonePreloading) {
    if (!this.player.isMuted()) {
      this.player.mute()
    }
    this.preloading = true
    this.onDonePreloading = onDonePreloading
    this.player.playVideo()
  }

  stopPreloading() {
    this.preloading = false
    if (this.onDonePreloading) {
      setTimeout(this.onDonePreloading, 100)    
    }
    this.onDonePreloading = false
  }

  onReady(event) {
    this.player = event.target
    this.player.mute()
    this.props.onReady(this)
  }

  onStateChange(event) {
    if (event.data === 1) {// playing
      if (this.preloading) {
        this.stopPreloading()
        setTimeout(() => {
          this.player.pauseVideo()
        }, 500)
      }
    }
    if (this.props.onStateChange) {
      this.props.onStateChange(event.data)
    }
  }
  render() {
    const w = window.innerWidth
    const h = .75 * w
    const z = this.props.video.zoom || 1
    return <div className="video-player" style={{
        width: w + 'px',
        height: h + 'px',
    }}>
      <div className="zoom-frame" style={{
        position: 'absolute',
        // width: (w * z) + 'px',
        // height: (h * z) + 'px',
        // left: ((w - z*w) / 2) + 'px',
        // top: ((h - z*h) / 2) + 'px',
      }}><div className="zoom-inner" style={{
        transform: 'scale('+z+')'
      }}>
        <YouTube
          videoId={this.props.video.videoId}
          opts={{
            height: h,
            width: w,
            playerVars: { // https://developers.google.com/youtube/player_parameters
              start: intervalStart(this.props.video.range),
              end: intervalEnd(this.props.video.range),
              autoplay: 0,
              playsinline: 1,
              controls: 0, 
              fs: 0, 
              modestbranding: 1, 
              showinfo: 0, 
              cc_load_policy: 0,
              rel : 0
            }
          }}
          onReady={this.onReady.bind(this)}
          onStateChange={this.onStateChange.bind(this)}
        /></div></div></div>
  }
}

export default VideoPlayer;